import * as yup from 'yup';
import sjisChecker from './sjis-checker';
import { isValidEmailAddress } from './check';
declare module 'yup' {
  interface StringSchema {
    isFullWidth(this: StringSchema, param: string): StringSchema;
    isFullWidthKana(this: StringSchema, param: string): StringSchema;
    isValidEmailAddress(this: StringSchema, param: string): StringSchema;
  }
}
const jpConfig = {
  mixed: {
    required: (param: yup.MessageParams) => `${param.label}は必須項目です`
  },
  string: {
    required: (param: yup.MessageParams) => `${param.label}は必須項目です`,
    min: (param: yup.MessageParams & {
      min: number;
    }) => `${param.label}は${param.min}文字以上でなければなりません`,
    max: (param: yup.MessageParams & {
      max: number;
    }) => `${param.label}は${param.max}文字以内にしてください`,
    matches: (param: yup.MessageParams & {
      regex: RegExp;
    }) => {
      switch (`${param.regex}`) {
        // パスワード用
        case '/^[a-zA-Z0-9]+$/':
          return `${param.label}は英数字のみ使用できます`;
        // パスワード用
        case '/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[\\d])/':
          return `${param.label}は大文字、小文字、数字をそれぞれ1文字以上含めてください`;
        // 確認コード
        case '/^\\d{4}$/':
          return `${param.label}は4桁の半角数字でなければなりません`;
        // 住所など
        case '/^[^ -~｡-ﾟ]+$/':
          return '※登録不可能な文字が入力されています';
        case '/^[^ -~\\uff61-\\uff9f]+$/':
          // /^[^ -~｡-ﾟ]+$/
          return '※登録不可能な文字が入力されています';
        // マンション名用（入力無しも許可）
        case '/^[^ -~｡-ﾟ]*$/':
          return '※登録不可能な文字が入力されています';
        case '/^[^ -~\\uff61-\\uff9f]*$/':
          // /^[^ -~｡-ﾟ]*$/
          return '※登録不可能な文字が入力されています';
        // カナ入力
        case '/^[ァ-ヶー]*$/':
          return '※全角カナで入力してください';
        case '/^[\\u30a1-\\u30f6\\u30fc]*$/':
          // /^[ァ-ヶー]*$/
          return '※全角カナで入力してください';
        // 郵便番号
        case '/^[0-9]{7}$/':
          return '※7桁の数字で入力してください';
        // 電話番号
        case '/^([0]{1}[0-9]{9,10})$/':
          return `${param.label}は10～11桁の数字で入力してください`;
        default:
          return `${param.label}が正しくありません`;
      }
    },
    email: (param: yup.MessageParams) => `${param.label}は有効なメールアドレスではありません`
  },
  number: {
    required: (param: yup.MessageParams) => `${param.label}を入力してください`,
    max: (param: yup.MessageParams & {
      max: number;
    }) => `${param.label}は${param.max + 1}円未満で入力してください`
  }
};
function isFullWidth(param: string) {
  return this.test('checkFullWidth', `${param}が正しくありません`, (value: string) => {
    return sjisChecker.fullWidth(value);
  });
}
yup.addMethod<yup.StringSchema>(yup.string, 'isFullWidth', isFullWidth);
function isFullWidthKana(param: string) {
  return this.test('checkFullWidthKana', `${param}が正しくありません`, (value: string) => {
    return sjisChecker.fullKana(value);
  });
}
yup.addMethod<yup.StringSchema>(yup.string, 'isFullWidthKana', isFullWidthKana);
function isValidEmailAddressRule(param: string) {
  return this.test('checkEmailAddressFormat', `${param}は有効なメールアドレスではありません`, (value: string) => {
    if (!value) {
      return true;
    }
    return isValidEmailAddress(value);
  });
}
yup.addMethod<yup.StringSchema>(yup.string, 'isValidEmailAddress', isValidEmailAddressRule);
yup.setLocale(jpConfig);
export default yup;